// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1CtfX","label":"Section_label__f7ysd","contentWrap":"Section_contentWrap__3Wy_A","footer":"Section_footer__2pL2b","footerInner":"Section_footerInner__1Uhpj"};